import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"

import * as actions from "../actions"
import { sortArrayByName } from "../helpers/arraySortByName"
import { PootsyTextInput } from "./FunctionalInputs"

class SearchWorker extends Component {
	state = {
		queuedCall: "",
		enteredText: "",
		weekStart: null,
	}
	handleSearchWorker = e => {
		e.stopPropagation()
		let { dispatch, onChange, searchOnlyActiveWorkers, agenda } = this.props
		let { value } = e.target
		if (searchOnlyActiveWorkers) {
			if (value.length === 0) {
				dispatch(actions.resetWorkerSuggestions())
				return
			}
			dispatch(
				actions.setWorkerSuggestions(
					agenda.activeWorkers.filter(entry => {
						return entry.attributes.display_name
							.toLowerCase()
							.includes(value.toLowerCase())
					})
				)
			)
			this.setState({ enteredText: value, weekStart: { ...agenda.weekStart } })
			return
		}
		let { queuedCall } = this.state
		clearTimeout(queuedCall)
		let futureCall
		onChange(e.target.value)
		if (value.length < 2) {
			dispatch(actions.resetWorkerSuggestions())
		} else {
			futureCall = setTimeout(() => this.fetchWorkerSuggestions(value), 800)
		}
		this.setState({ queuedCall: futureCall })
	}
	fetchWorkerSuggestions = search => {
		let { dispatch } = this.props
		let query = "?filter_name=" + search
		let init = { method: "GET" }
		dispatch(
			actions.simpleFetch(
				"/front/affiliates/affiliate_workers" + query,
				init,
				"WORKERSUGGESTIONS"
			)
		)
	}
	componentDidUpdate = () => {
		if (this.state.weekStart && this.state.weekStart._i !== this.props.agenda.weekStart._i) {
			this.reHandleSearchWorker()
		}
	}
	reHandleSearchWorker = () => {
		let { dispatch, searchOnlyActiveWorkers, agenda } = this.props
		let { enteredText } = this.state
		if (searchOnlyActiveWorkers) {
			if (enteredText.length === 0) {
				dispatch(actions.resetWorkerSuggestions())
				return
			}
			dispatch(
				actions.setWorkerSuggestions(
					agenda.activeWorkers.filter(entry => {
						return entry.attributes.display_name
							.toLowerCase()
							.includes(enteredText.toLowerCase())
					})
				)
			)
			this.setState({ weekStart: { ...agenda.weekStart } })
			return
		}
	}
	handleWorkerClick = entry => {
		let { dispatch, onClick } = this.props
		onClick(entry)
		dispatch(actions.resetWorkerSuggestions())
	}
	render() {
		let { t } = this.context
		let { workerSuggestions, value } = this.props
		workerSuggestions = sortArrayByName(workerSuggestions, "attributes", "display_name")
		return (
			<div className="SearchWorker">
				<PootsyTextInput
					label={t("search_for_specific_cleaner")}
					value={value}
					onChange={this.handleSearchWorker}
				/>
				{workerSuggestions.length > 0 && (
					<div className="worker-suggestions">
						{workerSuggestions.map(entry => (
							<div
								key={entry.id}
								className="worker-suggestion"
								onClick={this.handleWorkerClick.bind(this, entry)}
							>
								{entry.attributes.display_name}
							</div>
						))}
					</div>
				)}
			</div>
		)
	}
}

SearchWorker.contextTypes = { t: PropTypes.func }
SearchWorker.defaultProps = {
	searchOnlyActiveWorkers: false,
	onChange: () => {},
}
const mapStateToProps = state => ({
	currentAffiliate: state.redData.currentAffiliate,
	workerSuggestions: state.redData.workerSuggestions,
	agenda: state.redData.agenda,
})
export default connect(mapStateToProps)(SearchWorker)
